<div class="loading-overlay" *ngIf="loading$ | async">
  <div class="loading-content">
    <div class="spinner"></div>
  </div>
</div>
